require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-lackenbach.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-lackenbach");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-lackenbach!./.cache/json/betreuungseinrichtungen-oberpullendorf-lackenbach.json
// module id = 978
// module chunks = 231608221292675